import React, { Fragment, useEffect, useState } from "react";
import "./hrpolicy.css";
import { api } from "../../helper/api";
import Loading from "../Loading/Loading";
const HRPolicy = () => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		const loadMaterial = async () => {
			try {
				const response = await api({
					method: "post",
					url: "fetch.php",
					data: { fetch_hr_policy: true },
					headers: { "Content-Type": "multipart/form-data" },
				});
				const jsonData = await response.data;

				setData(jsonData.data[0]);
				setLoading(false);
			} catch (err) {
				setLoading(false);
			}
		};
		loadMaterial();
	}, []);
	return (
		<Fragment>
			{loading && <Loading />}

			<div className="hr-policy-container container">
				{data ? (
					<div
						className="hr-policy-content"
						dangerouslySetInnerHTML={{
							__html: data && data.hr_policy,
						}}
					></div>
				) : (
					"Content not Added"
				)}
			</div>
		</Fragment>
	);
};

export default HRPolicy;
